import { Project } from "../types";

export const projects: Project[] = [
  {
    title: "RoutineX - Powered by AI",
    description:
      "A habit tracker app with built-in offline AI assistant. Build lasting healthy habits with personalized AI coaching, smart reminders, and powerful tracking - all working 100% offline with complete privacy.",
    screenshots: [
      "/assets/routinex/playstore1.webp",
      "/assets/routinex/playstore2.webp",
      "/assets/routinex/playstore3.webp",
      "/assets/routinex/playstore4.webp",
      "/assets/routinex/playstore5.webp",
    ],
    techStack: [
      { icon: "/assets/tech/flutter.png", name: "Flutter" },
      { icon: "/assets/tech/dart.png", name: "Dart" },
    ],
    liveUrl:
      "https://play.google.com/store/apps/details?id=np.com.shashisharma.habittracker",
    git: "",
    featured: true,
  },
  {
    title: "Piece It - Jigsaw Puzzle",
    description:
      "Relaxing jigsaw puzzles with real interlocking pieces. Drag, snap, and solve beautiful images at your own pace. Solve, unwind, repeat!",
    screenshots: [
      "/assets/pieceit/playstore1.webp",
      "/assets/pieceit/playstore2.webp",
      "/assets/pieceit/playstore3.webp",
      "/assets/pieceit/playstore4.webp",
    ],
    techStack: [
      { icon: "/assets/tech/flutter.png", name: "Flutter" },
      { icon: "/assets/tech/dart.png", name: "Dart" },
    ],
    liveUrl:
      "https://play.google.com/store/apps/details?id=np.com.shashisharma.pieceit",
    git: "",
    featured: true,
  },
  {
    title: "Movie Library",
    description: "An implementation of The Movie DB API in Flutter.",
    screenshots: [
      "/assets/movie_library/image1.png",
      "/assets/movie_library/image2.png",
      "/assets/movie_library/image3.png",
    ],
    techStack: [
      { icon: "/assets/tech/flutter.png", name: "Flutter" },
      { icon: "/assets/tech/dart.png", name: "Dart" },
      { icon: "/assets/tech/firebase.png", name: "Firebase" },
    ],
    liveUrl: "",
    git: "https://github.com/sharmashashi/movie_library",
  },
  {
    title: "Weather Week",
    description:
      "A simple weather app that lets you search weather forecast up to 5 days by city name.",
    screenshots: [
      "/assets/weather_week/image1.png",
      "/assets/weather_week/image2.png",
      "/assets/weather_week/image3.png",
    ],
    techStack: [
      { icon: "/assets/tech/flutter.png", name: "Flutter" },
      { icon: "/assets/tech/dart.png", name: "Dart" },
    ],
    liveUrl: "",
    git: "https://github.com/sharmashashi/weather_week",
  },
  {
    title: "Flutter Pexels",
    description:
      "An app that lets you search and view photos and videos provided by Pexels API.",
    screenshots: [
      "/assets/flutter_pexels/image1.png",
      "/assets/flutter_pexels/image2.png",
      "/assets/flutter_pexels/video1.png",
      "/assets/flutter_pexels/video2.png",
    ],
    techStack: [
      { icon: "/assets/tech/flutter.png", name: "Flutter" },
      { icon: "/assets/tech/dart.png", name: "Dart" },
    ],
    liveUrl: "",
    git: "https://github.com/sharmashashi/flutter_pexels",
  },
  {
    title: "Chat App",
    description:
      "A secure chat app built with Flutter and Firebase. Features include encryption, audio messages, image sharing, and notes.",
    screenshots: [
      "/assets/chat/chat1.png",
      "/assets/chat/chat2.png",
      "/assets/chat/chat3.png",
      "/assets/chat/chat4.png",
    ],
    techStack: [
      { icon: "/assets/tech/flutter.png", name: "Flutter" },
      { icon: "/assets/tech/dart.png", name: "Dart" },
      { icon: "/assets/tech/firebase.png", name: "Firebase" },
    ],
    liveUrl: "https://gafgaf.web.app",
    git: "",
  },
  {
    title: "Remoteshelf - Cloud Storage Service",
    description:
      "A full-stack cloud storage service with secure file management, folder organization, and file sharing capabilities. Built with NestJS backend and React frontend using TypeScript.",
    screenshots: [],
    techStack: [{ icon: "/assets/tech/node.png", name: "Node.js" }],
    liveUrl: "",
    git: "https://github.com/Remoteshelf/Remoteshelf_backend",
  },
  {
    title: "Remoteshelf Frontend",
    description:
      "Frontend application for Remoteshelf cloud storage service. Features include file upload/download, folder management, progress tracking, and intuitive UI built with React and Vite.",
    screenshots: [],
    techStack: [{ icon: "/assets/tech/node.png", name: "Node.js" }],
    liveUrl: "",
    git: "https://github.com/Remoteshelf/Remoteshelf_frontend",
  },
];
